import { FeatureGuard } from "@core/components";

import { navigationItems } from "../config";
import SidebarNavigationItem from "./SidebarNavigationItem";

type SidebarNavigationItemsProps = {
  collapsed: boolean;
};

export const SidebarNavigationItems = ({
  collapsed,
}: SidebarNavigationItemsProps) => {
  const navItems = navigationItems.map((navItem) => ({
    ...navItem,
    hideName: collapsed,
  }));
  return (
    <ul className="space-y-4 overflow-auto">
      {navItems.map((navItem) => (
        <FeatureGuard
          features={navItem.features}
          key={navItem.name}
          logic="any-of"
        >
          <SidebarNavigationItem {...navItem} />
        </FeatureGuard>
      ))}
    </ul>
  );
};
